import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { Toggle } from 'libreact/lib/Toggle'

import Items from './Items'
import HelpIcon from '../../../HelpIcon'
import Checkbox from './Checkbox/index'
import enabled from './lib/enabled'
import onClickInput from './lib/onClickInput'
import onChangeInput from './lib/onChangeInput'

const Container = styled.div`
  border-bottom: ${props => (props.isItem || _.isEmpty(props.items)) ? 'none' : props.theme.borders.grey6};
  background-color: ${props => props.index % 2 && _.isEmpty(props.items) && props.theme.colors.grey6Light};

  @media (max-width: 768px) {
    padding: 0 20px;
    margin: 0 -20px;
  }
`

export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 20px 0px;
  }
`

const Label = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 1;
`

const HelpIconWithPadding = styled(HelpIcon)`
  padding: 0 5px;
`

const editable = ({ custom, filled, label }) => (custom && !filled) || !label

export default ({ form, baseName, items, on, isItem, children, ...rest }) => (
  <Toggle init={on}>
    {({ on, toggle }) => (
      <Container isItem={isItem} index={rest.index} items={items}>
        <InnerContainer>
          {editable(rest) && (
            <Checkbox
              baseName={baseName}
              on={on}
              toggle={toggle}
              items={items}
              isItem={isItem}
              editable={editable(rest)}
              {...rest}
            />
          )}
          {!editable(rest) && children({
            baseName,
            disabled: !enabled(form, baseName),
            onClick: onClickInput(form, baseName, isItem, items, on, toggle),
            readOnly: !!items,
            onChange: onChangeInput(form, baseName, isItem),
            label: (
              <Label>
                <Checkbox
                  baseName={baseName}
                  on={on}
                  toggle={toggle}
                  items={items}
                  isItem={isItem}
                  editable={editable(rest)}
                  {...rest}
                />
                {!rest.custom && rest.description && <HelpIconWithPadding {...rest} />}
              </Label>
            )
          })}
        </InnerContainer>

        {items && on && <Items form={form} baseName={`${baseName}.items`} children={children} />}
      </Container>
    )}
  </Toggle>
)
